<template>
  <div class="player">
    <div class="progress">

      <div v-if="(loading && started)"  class="loaderWrapper">
        <v-progress-linear
          indeterminate
          color="#2E2F34"
          style="border-radius: 46px;"
          :height="4"

        ></v-progress-linear>
      </div>

      <v-slider
        v-else
        v-model="currentTimeStamp"
        @change="setTime"
        @start="onInteractionStarted"
        @end="onInteractionEnded"
        color="#2E2F34"
        track-color="#BCC8C6"
        thumb-color="#2E2F34"
        :max="this.audio.duration || 100"
        :step="1"
        :min="0"
        height="4px"
      ></v-slider>

      <div class="progress-controls">
        <div class="timestamp">
          {{ (loading ? 0 : currentTime) | humanDuration}}
        </div>
        <div class="timeLeft">
          {{ (loading ? 0 : duration) | humanDuration }}
        </div>
      </div>
    </div>
    <div class="controls">
      <div @click="skip(-15)" class="minus15"></div>
      <div @click="playOrPause">
        <div v-if="paused" class="play">
        </div>
        <div v-else class="pause">
        </div>
      </div>
      <div @click="skip(15)" class="plus15"></div>
    </div>
  </div>
</template>

<script>

import moment from "moment";

export default {
  name: 'Player',
  props: ['src'],
  data() {
    return {
      duration: 0,
      audio: false,
      loading: true,
      started: false,
      paused: true,
      currentTimeStamp: 0,
      interactionInProgress: false,
    }
  },

  computed: {



    currentTime: {
      set: function (newValue) {
        if (newValue < 0) newValue = 0;
        if (newValue > this.audio.duration) newValue = this.audio.duration;

        console.log(`nv`, newValue)
        this.audio.currentTime = newValue;
        this.currentTimeStamp = newValue;
      },

      get: function () {
        return this.currentTimeStamp;
      }
    },

  },

  filters: {
    humanDuration: function (durationInSeconds) {
      durationInSeconds = durationInSeconds || 0;
      return moment.utc(durationInSeconds*1000).format('mm:ss');
    }
  },

  methods: {

    setTime: function (time) {
      this.audio.currentTime = time;
    },

    playOrPause: function () {
      this.started = true;
      if (this.audio.paused) {
        this.audio.play();
      } else {
        this.audio.pause();
      }
    },

    skip: function (durationInSeconds) {
      this.currentTime = this.audio.currentTime += durationInSeconds;
      this.$emit('skip', durationInSeconds);
    },

    onInteractionStarted: function () {
      this.interactionInProgress = true;
    },

    onInteractionEnded: function () {
      this.interactionInProgress = false;
    },

    onCanPlayThrough: function () {
      this.loading = false;
      this.duration = this.audio.duration;
      this.$emit('canPlayThrough');
    },

    onTimeUpdate: function () {
      if (this.interactionInProgress) return false;

      this.currentTimeStamp = this.audio.currentTime;
      this.duration = this.audio.duration;

      this.$emit('timeUpdate', {
        currentTime: this.audio.currentTime,
        duration: this.audio.duration,
        finished: this.audio.currentTime === this.audio.duration
      });

      if (this.audio.currentTime === this.audio.duration) {
        this.$emit('finished');
      }
    },

    onPause: function () {
      this.paused = true;
      this.$emit('pause');

    },

    onPlay: function () {
      this.paused = false;
      this.$emit('play');
    },

    onReadyStateUpdate: function () {
      console.log(`ready state`, this.audio.readyState);
      if (this.audio.readyState >= 3) {
        this.loading = false;
      } else {
        this.loading = true;
      }
    },

    onStalled: function () {
      this.onReadyStateUpdate();
    },

    onWaiting: function () {
      this.onReadyStateUpdate();
    },

    onSuspend: function () {
      this.onReadyStateUpdate();
    },

    onLoadStart: function () {
      this.onReadyStateUpdate();
    },

    onLoadedData: function () {
      this.onReadyStateUpdate();
    },


  },

  created() {
    this.audio = new Audio(this.src);

    this.audio.oncanplaythrough = this.onCanPlayThrough;
    this.audio.ontimeupdate = this.onTimeUpdate;
    this.audio.onplay = this.onPlay;
    this.audio.onpause = this.onPause;

    this.audio.onstalled = this.onStalled;
    this.audio.onwaiting = this.onWaiting;
    this.audio.onsuspend = this.onSuspend;
    this.audio.onloadstart = this.onLoadStart;
    this.audio.onloadeddata = this.onLoadedData;

  }
}
</script>

<style>
.v-messages {
  display: none !important;
}

.v-slider__track-container {
  height: 4px !important;
}

div.v-input.theme--light.v-input__slider > div > div.v-input__slot > div > div.v-slider__track-container > div.v-slider__track-background,
.v-slider__track-fill,
.v-slider__track-container
{
  border-radius: 46px !important;
}

.v-slider--horizontal {
  margin-right: 4px !important;
  margin-left: 4px !important;

}

.loaderWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
}

.player {
  height: 8.8125rem;
}


</style>
